
//import {httpsCallable} from "firebase/functions"
//import {ref,uploadBytes,getDownloadURL} from "firebase/storage"
import {NoticeProps} from "@/scripts/datatypes"
import { Component,Watch ,Mixins} from "vue-property-decorator"
import Common from '@/mixins/common'
import { ValidationObserver } from 'vee-validate'
import { Role, UserPublicProfile, UserSettings } from "@/common-datatypes"
import { getDoc } from "firebase/firestore"
import { ValidationFlags } from "vee-validate/dist/types/types"

@Component({
  components: {
    
  }
})

export default class EditUserSettings extends Mixins(Common) {
  isLoading = false
  initialized = false

  notice: NoticeProps = {}
  disablededitUserSettings = true
  userPublicProfile = {} as UserPublicProfile
  userSettings: UserSettings = {
    previewRequired: false
  }
 
  showModal = false

  observer = {} as InstanceType<typeof ValidationObserver>

  $refs!: {
    validationObserver: InstanceType<typeof ValidationObserver>;
  }

  get displayName(){
    return this.$t('text.name', {lastName: this.userPublicProfile.lastName || '', firstName: this.userPublicProfile.firstName || ''})
  }

  get existUser(){
    if(this.userPublicProfile.creationTime && this.userSettings.creationTime){
      return true
    }else{
      return false
    }
  }

  @Watch('initialized',{immediate: true})
  changeInitializedStatus(newVal: boolean){
    if(! newVal){
      this.notice = {
        message: this.$t('editUser.loadingUserData') as string,
        isShow: true,
        duration: 0,
        type: {'is-info': true}
      }
    }else if(! this.existUser){
      this.notice = {
        message: this.$t('editUser.noUserFound') as string,
        isShow: true,
        duration: 0,
        type: {'is-danger': true}
      }
    }else{
      this.notice = {
        isShow: false,
      }
    }
  }

  get theUserId(){
    return this.$route.params.userId || ''
  }

  mounted(){
    console.log('mounted')
  }

  updated(){
    console.log('updated')
    if(! this.observer.flags && this.$refs.validationObserver){
      this.observer = this.$refs.validationObserver
      this.$watch('observer.flags', (flags: ValidationFlags) => {
        this.disablededitUserSettings = ! flags.changed
      })
    }
  }

  get hasRoleStaff(){
    const roles = this.userPublicProfile.roles
    return Array.isArray(roles) && ['owner','admin','staff'].some((role) => { return roles.includes(role as Role)})
  }

  get hasRoleParent(){
    return !! (this.userPublicProfile.roles && this.userPublicProfile.roles.includes('parent'))
  }

  get hasRoleStudent(){
    return !! (this.userPublicProfile.roles && this.userPublicProfile.roles.includes('student'))
  }

  async created() {
    console.trace('created')
    try{
      this.$store.commit('setLoading',true)
      this.isLoading = true

      const [userPublicProfileDoc,userSettingsDoc] = await Promise.all([
        getDoc(this.$getUserPublicProfileDocRef(this.theUserId)),
        getDoc(this.$getUserSettingsDocRef(this.theUserId)),
      ])

      this.userPublicProfile = ((userPublicProfileDoc.exists() && userPublicProfileDoc.get('deleted') !== true) ? userPublicProfileDoc.data() : {}) as UserPublicProfile

      this.userSettings = userSettingsDoc.exists() ? userSettingsDoc.data() : {}

    }catch(error){
      //console.log(error)
    }finally{
      this.$store.commit('setLoading',false)
      this.isLoading = false
      this.initialized = true
    }
  }

  async editUserSettings(){
    try{
      this.notice = {
				isShow: false,
      }

      if(! await this.observer.validate()){
        return
      }

      const updateSettings = {
        ...this.userSettings
      }

      if(this.observer.flags.changed){

        this.$store.commit("setLoading",true);
        this.isLoading = true

        const result = await this.$updateDoc(this.$getUserSettingsDocRef(this.theUserId),updateSettings)

        console.log(result)


        if(result.exists()){
          this.userSettings = result.data() as UserSettings
        }

        this.notice = {
          message: this.$t('userSettings.updated') as string,
          isShow: true,
          type: {'is-success': true}
        }
        this.$nextTick(() => {
          this.observer.reset()
        })
      }else{
        this.notice = {
          message: this.$t('userSettings.noChangedFields') as string,
          isShow: true,
          type: {'is-info': true}
        }
      }
    }catch(error){
      console.table(error);
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('editUserSettings.error') as string
      
			const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

			const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
			this.notice = {
				message: errorMessage,
				isShow: true,
				type: {'is-danger': true}
      }
      
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
      this.disablededitUserSettings = true
      //this.observer.reset()
    }
  }
}
